// assets/ticker.js — versión con reciclaje de nodos (no hay saltos)
window.initTicker = function initTicker(selector) {
  const wrap = document.querySelector(selector);
  if (!wrap) return;

  const track = wrap.querySelector('.ticker');
  const groupA = wrap.querySelector('.ticker__group');
  if (!track || !groupA) return;

  let SPEED = 90; // px/s
  const cssSpeed = getComputedStyle(wrap).getPropertyValue('--speed').trim();
  if (cssSpeed) {
    const n = parseFloat(cssSpeed);
    if (!Number.isNaN(n) && n > 0) SPEED = n;
  }

  let pos = 0;
  let rafId;
  let last = performance.now();
  let running = false;

  // Duplicar dinámicamente hasta que el track cubra 2× el ancho visible
  function fill() {
    const neededWidth = wrap.offsetWidth * 2;
    while (track.scrollWidth < neededWidth) {
      const clone = groupA.cloneNode(true);
      track.appendChild(clone);
    }
  }

  function step(now) {
    if (!running) return;
    const dt = (now - last) / 1000;
    last = now;

    pos -= SPEED * dt;

    // cuando el primer hijo sale por completo de la izquierda, lo movemos al final
    const first = track.firstElementChild;
    if (first && pos <= -first.scrollWidth) {
      pos += first.scrollWidth;
      track.appendChild(first); // reciclar
    }

    track.style.transform = `translate3d(${pos}px,0,0)`;
    rafId = requestAnimationFrame(step);
  }

  function start() {
    cancelAnimationFrame(rafId);
    pos = 0;
    last = performance.now();
    fill();
    running = true;
    rafId = requestAnimationFrame(step);
  }

  function stop() {
    running = false;
    if (rafId) cancelAnimationFrame(rafId);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(start);
  } else {
    window.addEventListener('load', start, { once: true });
  }

  // Refill en resize
  let rzTimer;
  window.addEventListener('resize', () => {
    clearTimeout(rzTimer);
    rzTimer = setTimeout(() => {
      stop();
      // limpiar extras y dejar solo el primer grupo
      while (track.childElementCount > 1) {
        track.removeChild(track.lastElementChild);
      }
      start();
    }, 150);
  });
};
